// Service for fetching binary data (images/documents)
// Endpoint: /emr/workspaces/{workspace_id}/patients/{patient_id}/binary/

import { useMutation } from "react-query";
import servicesUtils from "../../../utils/servicesUtils";
var useBinaryService = function useBinaryService(workspaceId, patientId) {
  return useMutation(function (data) {
    return servicesUtils.postService("/emr/workspaces/".concat(workspaceId, "/patients/").concat(patientId, "/binary/"), data);
  });
};
export default useBinaryService;